// @flow
import React from 'react'

type Props = {
  value: string,
  label: string,
  background?: string
}

const BadgeWithLabel = (props: Props): React$Element<'div'> => <div style={{
  display: 'inline-block',
  width: '70px',
  height: '50px',
  borderRadius: '4px',
  backgroundColor: props.background || '#1aa8e2',
  margin: '10px',
  color: 'white',
  fontFamily: 'Lato',
  textAlign: 'center'
}}>
  <span style={{fontWeight: 'bold', fontSize: '23px'}}>
    {props.value}
  </span>
  <br />
  <span style={{position: 'relative', top: '-4px', opacity: 0.5}}>
    {props.label}
  </span>
</div>

export default BadgeWithLabel



// WEBPACK FOOTER //
// ./app/javascript/packs/components/shared/BadgeWithLabel.js